import React from "react";
import { colors } from "src/styles";
import { DBVendor } from "src/types";
import styled from "styled-components";
import VendorLogo from "../Logo";
import { VendorsTableProps } from "../types";

export const VendorsTable = ({ isLoading, headers, data, onRowClick }: VendorsTableProps) => {
  if (isLoading) {
    return <EmptyRow>Loading...</EmptyRow>;
  }

  if (!data.length) {
    return <EmptyRow>No vendors assigned.</EmptyRow>;
  }

  return (
    <TableWrap>
      <TableHeader>
        {headers.map((header) => (
          <span key={header}>{header}</span>
        ))}
      </TableHeader>
      {data.map(({ id, logo, address, name }: DBVendor) => {
        return (
          <TableRow key={id} onClick={() => onRowClick(id)}>
            <IdPill>{id.slice(0, 8).toUpperCase()}</IdPill>
            <LogoCell>
              <VendorLogo logoFileName={logo} />
            </LogoCell>
            <NameCell>{name || "-"}</NameCell>
            <MutedCell>{address || <ItalicDash>-</ItalicDash>}</MutedCell>
          </TableRow>
        );
      })}
    </TableWrap>
  );
};

const EmptyRow = styled.div`
  padding: 20px 16px;
  color: ${colors.grey.dark6};
  font-size: 13px;
`;

const TableWrap = styled.div`
  overflow-x: auto;
`;

const TableGridBase = styled.div`
  display: grid;
  grid-template-columns: 130px 100px minmax(220px, 1fr) minmax(260px, 1.2fr);
  gap: 8px;
  align-items: center;
  min-width: 760px;
`;

const TableHeader = styled(TableGridBase)`
  padding: 12px 16px;
  color: ${colors.grey.dark6};
  border-bottom: 1px solid ${colors.grey.light3};
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
`;

const TableRow = styled(TableGridBase)`
  padding: 14px 16px;
  border-top: 1px solid ${colors.grey.light3};
  cursor: pointer;

  &:hover {
    background: ${colors.grey.light6};
  }
`;

const IdPill = styled.span`
  border: 1px solid ${colors.grey.light4};
  background: ${colors.grey.light6};
  font-size: 11px;
  font-weight: 700;
  color: ${colors.black.light1};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 4px 8px;
  width: fit-content;
`;

const LogoCell = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NameCell = styled.span`
  font-size: 13px;
  color: ${colors.black.dark1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MutedCell = styled.span`
  font-size: 12px;
  color: ${colors.grey.dark6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItalicDash = styled.span`
  color: ${colors.grey.dark7};
  font-style: italic;
`;
